import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CuotasMod, CuotasModFormValues } from '../models/CuotasMod';
import { DPI, DPIFormValues } from '../models/dpi';
import { CATCursosL, createCATCursos } from '../models/CATCursos';
import { CATEdiciones, CATEdicionesL } from '../models/CATEdiciones';
import {getTranx, getTranxTipoCta} from '../models/getTranxTipoCta';
import { ExoneracionesDetail, ExoneracionesList, ExoneracionesMod, ExoneracionesModFormValues } from '../models/ExoneracionesMod';
import { isDebuggerStatement } from 'typescript';


export default class ExoneracionesStore {
    CCTOperacionRegistry = new Map<any, ExoneracionesMod>();
    ExoDetail = new Map<any, ExoneracionesDetail>();
    CATCoursesRegistry = new Map<any,createCATCursos>();
    CATEdicionesRegistry = new Map<any,CATEdiciones>();
    TransXTipoCta = new Map<any,getTranxTipoCta>();
    TransX = new Map<any,getTranx>();
   
    DPIRegistry = new Map<any, ExoneracionesMod>();
    DPIRegistrys = new Map<any, ExoneracionesList>(); 
    getExoneraciones = new Map<any, ExoneracionesDetail>(); 
    CATEdicionesRegistry3 = new Map<any,CATEdicionesL>();
    

    selectedExoneracionMod: ExoneracionesMod | undefined = undefined;
    selectedDPI: DPI | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    consulta=''; 


    constructor() {
        makeAutoObservable(this)
    }

    get PlanCuotas() {
    
        return Array.from(this.CCTOperacionRegistry.values());
    }

    get CATCoursesInfo(){
        return Array.from(this.CATCoursesRegistry.values());
    }
    get dpiByCodigos() {
        return Array.from(this.DPIRegistry.values());
    }
    get dpiByCodigo() {
        return Array.from(this.DPIRegistrys.values());
    }
    get exoneracionDetail() {
        return Array.from(this.ExoDetail.values());
    }
    get exoneracionDetail2() {
        return Array.from(this.ExoDetail.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTOperacionRegistry
    }


    loadEditions = async(codigocurso:number)=>{
        if(codigocurso==undefined){
            codigocurso=0;
        }
        try{
            const getEditions:CATEdiciones[]=await agent.getCATEdiciones.getEditionsByCourse(codigocurso);
            return Array.from(getEditions);
        }catch{
            return Array.from(this.CATEdicionesRegistry.values());
        }

    }  
    
    loadEditions2 = async(id:number)=>{
        if(id==undefined){
            id=0;
        }
        try{
            const getEditions:CATEdicionesL[]=await agent.getCATEdiciones.getEditionsByCourse2(id);
            return Array.from(getEditions);
        }catch{
            return Array.from(this.CATEdicionesRegistry3.values());
        }

    }

    transXCuenta = async(curso:string)=>{
        try{
            const getTrans:getTranx[]= await agent.Exoneracion.transxPorCuenta(curso);
            return Array.from(getTrans);            
        }catch{
            return Array.from(this.TransX.values());
        }
    }

    loadCoursesL = async()=>{
        const getCursos:CATCursosL[] = await agent.CATCursos.getCoursesL();
        return Array.from(getCursos);
        
     }

     loadExoneraciones = async()=>{
         try{
        const getExoneraciones:ExoneracionesList[] = await agent.Exoneracion.getExoneracion();
        getExoneraciones.forEach(element => {
            this.setExoneraciones(element);
        })
        return Array.from(getExoneraciones);
    }catch{
        return Array.from(this.CCTOperacionRegistry.values())
    }
     }

     loadExonDetail = async(id:number)=>{
         var contador = 0
        try{
       const getExoneracion:ExoneracionesDetail[] = await agent.Exoneracion.getExoDetail(id);

       if(contador === 0){

        getExoneracion.forEach(element => {
            this.setExoneracion(element);
                })
        contador = contador + 1
       }      
       return Array.from(getExoneracion);
   }catch{
       return Array.from(this.ExoDetail.values())
   }
   
    }


     loadIdcontrol = async(idcontrol:number)=>{
        try{
       const getExoneraciones:ExoneracionesMod[] = await agent.Exoneracion.getIdcontrol(idcontrol);
       
       getExoneraciones.forEach(element => {
           this.setExoneraciones1(element);
       })
       return Array.from(getExoneraciones);
   }catch{
       return Array.from(this.CCTOperacionRegistry.values())
   }
    }




     loadCuotass = async(catCursoId: string, catEdicionId: string)=>{
        const consulta:CuotasMod[] =  await agent.Cuotas.details(catCursoId, catEdicionId);
        return Array.from(consulta)
        
        
     }


     private setExoneraciones = (id: ExoneracionesList) => {
        this.DPIRegistrys.set(id.idcontrol, id);
    }


    private setExoneracion = (id: ExoneracionesDetail) => {
        this.ExoDetail.set(id.idcontrol, id);
    }



    private setExoneraciones1 = (id: ExoneracionesMod) => {
        this.DPIRegistry.set(id.idcontrol, id);
    }
  
    
    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createExoneracionMod = async (ExoneracionMod: ExoneracionesModFormValues) => {
        try {
            await agent.Exoneracion.create(ExoneracionMod);
            runInAction(() => {
                this.selectedExoneracionMod = ExoneracionMod;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }  
    private getdpiByCodigos = (idcontrol: any) => {
        return this.DPIRegistry.get(idcontrol);
    }


    updateExoneracionMod = async (ExoneracionesMod: ExoneracionesModFormValues) => {
        try {
            await agent.Exoneracion.updateExoneraciones(ExoneracionesMod);
            runInAction(() => {
                if (ExoneracionesMod.idcontrol) {
                    let updateExoneracioneS = {...this.getdpiByCodigos(ExoneracionesMod.idcontrol), ...ExoneracionesMod}
                    this.DPIRegistry.set(ExoneracionesMod.idcontrol, updateExoneracioneS  as ExoneracionesMod);
                    this.selectedExoneracionMod = updateExoneracioneS  as ExoneracionesMod
                    this.loading = false;
                }
                   
            } )
        } catch (error) {
        }
    }
}


   


export const CoursesData = async () => {
    try{
        const getCursos:createCATCursos[] = await agent.CATCursos.getCourses();
    }
    catch{
    }
}
